import { useParams } from "react-router-dom";
import { useSimulatorConfiguration } from "./useSimulatorConfiguration";
import { ConfigurationViewGuard } from "./parts/ConfigurationViewGuard";
import { QuackchatChannelLayoutConfiguration } from "./quackchat-channel/layout-configuration/QuackchatChannelLayoutConfiguration";

export function LayoutConfiguration() {
  const { simulatorId } = useParams();
  const { simulator } = useSimulatorConfiguration(simulatorId);
  const channel = simulator?.channel;

  return (
    <ConfigurationViewGuard view={"layout"}>
      {channel === "autonomous_quackchat" && (
        <QuackchatChannelLayoutConfiguration simulatorId={simulatorId} />
      )}
    </ConfigurationViewGuard>
  );
}
